import React from 'react'
import { useTranslation } from 'react-i18next'
import Popup from 'components/popup/Popup'
import AppBtn, { AppBtnColor, AppBtnSize } from 'components/btn/AppBtn'
import './ZeroClientsPopup.scss'

interface ZeroClientsPopupProps {
  onClose: () => void
  onAdd: () => void
}

const ZeroClientsPopup: React.FC<ZeroClientsPopupProps> = ({
  onClose,
  onAdd,
}) => {
  const { t } = useTranslation()

  return (
    <Popup closePopup={onClose}>
      <div className="zero-clients-popup">
        <div className="title">
          <span>{t('Ошибка!')}</span>
        </div>
        <div className="body">
          <div className="icon-bg">
            <span className="an-ico an-ico-info-circle"></span>
          </div>
          <p className="message-big">
            {t('Количество гостей не указано или равно нулю')}
          </p>
          <p className="message-small">
            {t(
              'Пожалуйста, добавьте количество гостей перед закрытием плана-меню',
            )}
          </p>
        </div>
        <div className="buttons-block">
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.outlineViolet}
            title={t('Отмена')}
            onClick={onClose}
          />
          <AppBtn
            sized={AppBtnSize.md}
            color={AppBtnColor.violetWhite}
            title={t('Добавить')}
            iconClassName="an-ico an-ico-add"
            onClick={() => {
              onAdd()
            }}
          />
        </div>
      </div>
    </Popup>
  )
}

export default ZeroClientsPopup
